import React from 'react';
import styled from 'styled-components';
import { Heart, Code } from 'lucide-react';
import { theme, media } from '../../styles/theme';

const FooterContainer = styled.footer`
  position: fixed;
  bottom: 0;
  left: ${({ hasSidebar }) => hasSidebar ? '260px' : '0'};
  right: 0;
  padding: ${theme.spacing.md} ${theme.spacing.xl};
  background: linear-gradient(135deg, ${theme.colors.white} 0%, ${theme.colors.secondary} 100%);
  border-top: 2px solid ${theme.colors.border};
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
  z-index: ${theme.zIndex.fixed};
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px);
  transition: left ${theme.transitions.duration.base};

  ${media.down.lg} {
    left: 0;
    padding: ${theme.spacing.sm} ${theme.spacing.md};
  }

  ${media.down.sm} {
    padding: ${theme.spacing.xs} ${theme.spacing.sm};
    flex-direction: column;
    gap: ${theme.spacing.xs};
  }
`;

const FooterContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  flex-wrap: wrap;
  justify-content: center;
`;

const FooterText = styled.p`
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.textSecondary};
  margin: 0;
  font-family: ${theme.typography.fontFamily};
  text-align: center;
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};

  ${media.down.sm} {
    font-size: ${theme.typography.fontSize.xs};
    flex-direction: column;
    gap: ${theme.spacing.xs};
  }
`;

const BrandName = styled.a`
  color: ${theme.colors.primary};
  font-weight: ${theme.typography.fontWeight.bold};
  text-decoration: none;
  transition: all ${theme.transitions.duration.base} ${theme.transitions.easing.easeOut};
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.md};
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
  }

  &:hover {
    color: ${theme.colors.white};
    background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.accentTeal} 100%);
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.md};

    &::before {
      left: 100%;
    }
  }

  svg {
    width: 16px;
    height: 16px;
    transition: transform 0.3s;
  }

  &:hover svg {
    transform: rotate(360deg);
  }
`;

const HeartIcon = styled(Heart)`
  color: ${theme.colors.accent};
  animation: pulse 2s ease-in-out infinite;
  width: 14px;
  height: 14px;
  fill: currentColor;

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
  }
`;

function Footer({ hasSidebar = true }) {
  return (
    <FooterContainer hasSidebar={hasSidebar}>
      <FooterContent>
        <FooterText>
          <span>Made with</span>
          <HeartIcon />
          <span>by</span>
          <BrandName href="https://www.artifycode.com" target="_blank" rel="noopener noreferrer">
            <Code size={14} />
            &lt;artifycode&gt;
          </BrandName>
        </FooterText>
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer;

